import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'src/app/shared';
import { LayoutComponent } from './components/layout/layout.component';
import { HeaderComponent } from './components/header/header.component';
import { InfoDialogComponent } from './components/info-dialog/info-dialog.component';
import { UsersnapComponent } from './components/usersnap/usersnap.component';
import { SafePipe } from 'src/app/layout/pipes/safe.pipe';

@NgModule({
  declarations: [LayoutComponent, HeaderComponent, InfoDialogComponent, UsersnapComponent, SafePipe],
  imports: [CommonModule, SharedModule, TranslateModule.forChild(), RouterModule],
  exports: [LayoutComponent],
})
export class LayoutModule {}
